import { ChangeDetectionStrategy, Component } from '@angular/core';
import { Cy_Katalog } from '@features/cypress';
import { PageHeaderComponent } from '@shared/ui/components';
import { SeznamSablonFilterFormService } from '../../services/seznam-sablon-filter-form.service';
import { SeznamSablonOverviewFilterComponent } from './seznam-sablon-overview-filter/seznam-sablon-overview-filter.component';

@Component({
  selector: 'reza-seznam-sablon-main',
  templateUrl: './main.component.html',
  imports: [PageHeaderComponent, SeznamSablonOverviewFilterComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [SeznamSablonFilterFormService],
})
export class SeznamSablonMainPageComponent {
  readonly Cy_Katalog = Cy_Katalog;
}
